// src/utils/phoneUtils.js
import { parsePhoneNumberFromString, isValidPhoneNumber } from 'libphonenumber-js';
import { countries } from '../constants/countres';

/**
 * ✅ تكوين رقم الهاتف الكامل من كود الدولة والرقم الوطني
 * @param {string} countryPhone - كود الدولة (مثل "20")
 * @param {string} nationalNumber - الرقم الوطني (مثل "1234567890")
 * @returns {string} - الرقم الكامل (مثل "+201234567890")
 */
export const formatFullPhoneNumber = (countryPhone, nationalNumber) => {
    if (!nationalNumber || !countryPhone) return '';
    // إزالة + و 0 من البداية
    const cleanNumber = nationalNumber.replace(/^\+?0*/, '');
    return `+${countryPhone}${cleanNumber}`;
};

/**
 * ✅ التحقق من صحة رقم الهاتف
 * @param {string} countryPhone - كود الدولة
 * @param {string} nationalNumber - الرقم الوطني
 * @returns {object} - {isValid: boolean, message: string}
 */
export const validatePhoneNumber = (countryPhone, nationalNumber, lang = 'ar') => {
    if (!nationalNumber || !countryPhone) {
        return { isValid: false, message: lang === 'ar' ? 'الرجاء إدخال رقم الهاتف' : 'Please enter phone number' };
    }

    const country = countries.find(c => c.phone === countryPhone);
    if (!country) {
        return { isValid: false, message: lang === 'ar' ? 'الدولة غير صحيحة' : 'Invalid country' };
    }

    const fullNumber = formatFullPhoneNumber(countryPhone, nationalNumber);

    try {
        const isValid = isValidPhoneNumber(fullNumber, country.code);
        if (!isValid) {
            return {
                isValid: false,
                message: lang === 'ar'
                    ? 'رقم الهاتف غير صحيح للدولة المختارة'
                    : 'Invalid phone number for selected country'
            };
        }
        return { isValid: true, message: '' };
    } catch (error) {
        return {
            isValid: false,
            message: lang === 'ar' ? 'رقم الهاتف غير صحيح' : 'Invalid phone number'
        };
    }
};

/**
 * ✅ فصل رقم الهاتف الكامل إلى كود دولة ورقم وطني
 * @param {string} fullPhoneNumber - الرقم الكامل (مثل "+201234567890")
 * @returns {object} - {countryPhone: string, nationalNumber: string}
 */
export const parseFullPhoneNumber = (fullPhoneNumber) => {
    if (!fullPhoneNumber) return { countryPhone: countries[0].phone, nationalNumber: '' };

    try {
        const parsed = parsePhoneNumberFromString(fullPhoneNumber);
        if (parsed) {
            const country = countries.find(c => c.code === parsed.country);
            return {
                countryPhone: country?.phone || countries[0].phone,
                nationalNumber: parsed.nationalNumber
            };
        }
    } catch (e) {
        console.error('Error parsing phone:', e);
    }

    return { countryPhone: countries[0].phone, nationalNumber: fullPhoneNumber.replace(/\D/g, '') };
};
